import { Camera } from 'lucide-react';

import { lang } from '@lang';
import { useAppToast, useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type SnapshotFeatureParams = FeatureHoookParams;
export const useSnapshotFeature = (_params: SnapshotFeatureParams = {}): Feature<string | null> => {
	const [controller] = useDesign();
	const appToast = useAppToast();

	const [disabled, tooltip] = (() => {
		if (controller === null) return [true, lang.social.tooltip.noDesign];
		return [false, lang.social.tooltip.snapshot];
	})();

	return {
		name: 'shareLink',
		label: lang.social.label.shareLink,
		icon: (props = {}) => <Camera {...props} />,
		tooltip,
		disabled,
		value: controller?.getImage() ?? null,
		hidden: false,
		handler: () => {
			appToast.info({ title: lang.social.message.downloadSnapshot });
		}
	};
};
